import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MuiCard from '../components/MuiCard';
import NavBarPlanes from '../components/NavBarPlanes';
import bolso from '../assets/Bolso.jpg'
import accidente from '../assets/Accidentes.jpg'
import empleo from '../assets/Empleabilidad.jpg'
import portatil from '../assets/portatil.jpg';
import notebook from '../assets/notebook.jpg'
import prudential from '../assets/prudential-small.svg'
import life from '../assets/life-small.svg'
import bbva from '../assets/bbva-small.svg'
import hogar from '../assets/Hogar.jpg'
import { Grid, Box } from '@mui/material'
import { setAllSteps, setCurrentTab, setErrorEncrypt, setFrequentQuestions } from '../redux/reducer/stepReducer/stepReducer';


export const Planes = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { paramsMus } = useSelector((state) => state.firstStep);
    const { menu, codemp } = useSelector(state => state.adminReducer.login);
    const infoPlanes = [
        {
            id: '1BP',
            icon: 'BP',
            title: 'Bolso Protegido',
            caption: 'Protegé lo que llevás con vos',
            description: 'Cuidá todo lo que llevás en tu bolso, mochila, o porta notebook.',
            codcia: menu?.find((e) => e.codsec === 19)?.codcia,
            fecpro: menu?.find((e) => e.codsec === '19')?.fecpro,
            codsec: '19',
            image: bolso,
            logo: life,
            size: '30%',
            codemp: [1, 2, 51, 52],
        },
        {
            id: '2SH',
            icon: 'SH',
            title: 'Seguro Hogar',
            caption: 'Tu hogar es lo más importante',
            description: '¡Asegura 100% online tu hogar este mes!',
            codcia: menu?.find((e) => e.codsec === 8)?.codcia,
            fecpro: menu?.find((e) => e.codsec === '8')?.fecpro,
            codsec: '8',
            image: hogar,
            logo: life,
            size: '30%',
            codemp: [1, 2, 51, 52],
        },
        {
            id: '3AP',
            icon: 'AP',
            title: 'Accidentes Personales',
            caption: 'Una tranquilidad para vos y tu familia',
            description: 'Te acompañamos con esos imprevistos a los que te puedas enfrentar.',
            codcia: menu?.find((e) => e.codsec === 12)?.codcia,
            fecpro: menu?.find((e) => e.codsec === '12')?.fecpro,
            codsec: '12',
            image: accidente,
            logo: prudential,
            size: '30%',
            codemp: [2, 52],
        },
        // {
        //     id: '4EP',
        //     icon: 'EP',
        //     title: 'Empleo Protegido',
        //     caption: 'Un mundo de oportunidades',
        //     description: 'Tu trabajo refleja tu esfuerzo y es la base de tus ingresos, aseguralo ya.',
        //     codcia: menu?.find((e) => e.codsec === '62')?.codcia,
        //     fecpro: menu?.find((e) => e.codsec === '62')?.fecpro,
        //     codsec: '62',
        //     image: empleo,
        // },
        {
            id: '5EP',
            icon: 'NP',
            title: 'Notebook Protegida',
            caption: 'Tu herramienta de trabajo, asegurada',
            description: 'Protegemos tu notebook o tablet contra el robo o daño accidental en la vía pública. ',
            codcia: menu?.find((e) => e.codsec === 159)?.codcia,
            fecpro: menu?.find((e) => e.codsec === '159')?.fecpro,
            codsec: '159',
            image: notebook,
            logo: bbva,
            size: '20%',
            codemp: [2, 52],
        },
        {
            id: '6EP',
            icon: 'TP',
            title: 'Tecnología Portátil',
            caption: 'Asegurá tus dispositivos',
            description: 'Cuidá todos los equipos electrónicos portátiles de uso diario que tengas ante su robo en la vía pública.',
            codcia: menu?.find((e) => e.codsec === 161)?.codcia,
            fecpro: menu?.find((e) => e.codsec === '161')?.fecpro,
            codsec: '161',
            image: portatil,
            logo: bbva,
            size: '20%',
            codemp: [2, 52],
        },
    ]

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = 'Estoy a punto de refrescarme';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        localStorage.removeItem("insured");
        localStorage.removeItem("productType");
        localStorage.removeItem("dataNotebook");
    }, [])

    useEffect(() => {
        dispatch(setFrequentQuestions(''))
        dispatch(setAllSteps(0));
        dispatch(setCurrentTab(0));
    }, []);

    return (
        <Grid container display={'flex'}>
            <Grid item xs={12} justifyContent={'center'} height={"60px"} >
                <NavBarPlanes />
            </Grid>
            <Grid container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', overflowY: 'scroll', height: "calc(100vh - 64px)" }} >
                <Grid item xs={12} lg={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', margin: '10px' }}>
                        <h3 style={{ fontSize: '1.8 rem', marginTop: '5px' }}>Tu seguro</h3>
                        <h3 style={{ fontSize: '1.8 rem' }}>totalmente online</h3>
                        <p style={{ fontSize: '1rem', marginLeft: "3vw" }}>Cotizá sin compromiso, elegí entre los planes y contratá tu seguro ¡En 3 pasos!</p>
                    </Box>
                </Grid>
                <Grid
                    container
                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }}
                    marginBottom={10}
                    paddingBottom={10}
                    marginRight={'5vw'}
                    marginLeft={'5vw'}
                    display={'flex'}
                    justifyContent={'center'}
                >
                    {
                        infoPlanes.filter((e) => e.codemp.includes(codemp) && e.codsec !== 159 && e.codsec !== 161)?.map((infoPlan, index) => {
                            return (
                                <Grid item xs={12} sm={6} md={'auto'} lg={'auto'} xl={'auto'} key={index} display={'flex'} justifyContent={'center'}>
                                    <MuiCard
                                        key={index}
                                        id={infoPlan.id}
                                        icon={infoPlan.icon}
                                        title={infoPlan.title}
                                        fecpro={infoPlan.fecpro}
                                        caption={infoPlan.caption}
                                        description={infoPlan.description}
                                        codcia={infoPlan.codcia}
                                        codsec={infoPlan.codsec}
                                        image={infoPlan.image}
                                        logo={infoPlan.logo}
                                        size={infoPlan.size}
                                    />
                                </Grid>
                            )
                        })
                    }
                </Grid>
                <Grid
                    container
                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" } }}
                    display={'flex'}
                    justifyContent={'center'}
                >
                    {
                        infoPlanes.filter((e) => e.codemp.includes(codemp) && (e.codsec === 159 || e.codsec === 161))?.map((infoPlan, index) => {
                            return (
                                <Grid item xs={12} sm={6} md={4} lg={4} xl={'auto'} key={index} display={'flex'} justifyContent={'center'}>
                                    <MuiCard
                                        key={index}
                                        id={infoPlan.id}
                                        icon={infoPlan.icon}
                                        title={infoPlan.title}
                                        fecpro={infoPlan.fecpro}
                                        caption={infoPlan.caption}
                                        description={infoPlan.description}
                                        codcia={infoPlan.codcia}
                                        codsec={infoPlan.codsec}
                                        image={infoPlan.image}
                                        logo={infoPlan.logo}
                                        size={infoPlan.size}
                                    />
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </Grid>
        </Grid >
    )
}

export default Planes